import { BaseService } from './base.service';
import { SearchEntities } from '../common/enums/search-entities.enum';
import { GenericApiResponse } from '../models/generic/generic-api-response';
import { Uris } from '../common/constants';


export interface ISearchService {
  searchEntity: (param: { entity?: SearchEntities | SearchEntities[] | string, q?: string, $limit?: number,
    apartment?: number[], block?: number[], problem?: number, role?: number[] }) => Promise<any>
  searchEntityById: (id: number) => Promise<any>
}

export class SearchService extends BaseService implements ISearchService {
  /**
   *
   */
  constructor () {
    super('search')
  }
  /** Get list contractors, welcoming, participant */
  async searchEntity (param: { entity?: SearchEntities | SearchEntities[] | string,
    q?: string, $limit?: number, apartment?: number[], block?: number[], problem?: number, role?: number[] }): Promise<any> {
    const query: any = {}
    if (param.entity)
      query.entity = param.entity
    if (param.q)
      query.q = param.q
    if (param.$limit)
      query.$limit = param.$limit
    if (param.apartment)
      query.apartment = param.apartment
    if (param.block)
      query.block = param.block
    if (param.problem)
      query.problem = param.problem
    if (param.role)
      query.role = param.role

    return super.get(this._path, query)
      .then((data: any[]) => {
        return Promise.resolve(data)
      })
      .catch(error => console.log(error))
  }

  async searchEntityById(id: number) : Promise<any> {
    return super.get(Uris.SearchId.replace(':id',id.toString()))
        .then(entity=> Promise.resolve(entity))
        .catch(err=> Promise.reject(err))
  }
}



// WEBPACK FOOTER //
// ./src/services/search.service.ts